import { render, staticRenderFns } from "./Instrucciones.vue?vue&type=template&id=baf4d160&scoped=true&"
import script from "./Instrucciones.vue?vue&type=script&lang=js&"
export * from "./Instrucciones.vue?vue&type=script&lang=js&"
import style0 from "./Instrucciones.vue?vue&type=style&index=0&id=baf4d160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf4d160",
  null
  
)

export default component.exports